import styled from 'styled-components';
import { ButtonUnstyled } from '../Button/ButtonUnstyled.js';
import { baseLinkStyle } from '../Link/Link.styles.js';

const FakeLinkButton = styled(ButtonUnstyled) `
  ${baseLinkStyle}
`;

export { FakeLinkButton };
